import { createFileRoute } from "@tanstack/react-router";
import { ReviewNamePlatePhoto } from "@/components/installFlowV2/review-name-plate-photo";
import { z } from "zod";

export const Route = createFileRoute("/installFlow/review-name-plate-photo")({
  component: ReviewNamePlatePhoto,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
});
